import { useEffect, useState } from "react";

// Media Queries as numbers for e.g. screen.innnerWith with useState
export const mediaQueriesNumbers = {
    // mobileMax: 600,
    mobileXs: 690,
    mobileMax: 1000,
    tabletMin: 601,
    tabletMax: 900,
    laptopMin: 901,
    laptopMax: 1280,
    desktopMin: 1281,
    desktopMax: 1530,
    desktopXlMin: 1531,

    pageHeaderResponsive2elementsMax: 1088,
    pageHeaderResponsive3elementsMax: 1347,

    ScreenHeightMax: 900,
    ScreenHeightMin: 710,
  };
  
  // Media Queries as strings with media query intervals for e.g. css styling
  export const mediaQueries = {
    mobileXs: `@media (max-width: ${mediaQueriesNumbers.mobileXs}px)`,
    mobile: `@media (max-width: ${mediaQueriesNumbers.mobileMax}px)`,
    tablet: `@media (min-width: ${mediaQueriesNumbers.tabletMin}px) and (max-width: ${mediaQueriesNumbers.tabletMax}px)`,
    laptop: `@media (min-width: ${mediaQueriesNumbers.laptopMin}px) and (max-width: ${mediaQueriesNumbers.laptopMax}px)`,
    desktop: `@media (min-width: ${mediaQueriesNumbers.desktopMin}px) and (max-width: ${mediaQueriesNumbers.desktopMax}px)`,
    desktopXl: `@media (min-width: ${mediaQueriesNumbers.desktopXlMin}px)`,

    columnCount2: `@media (min-width: 700px)`,
    columnCount3: `@media (min-width: 1360px)`,
    columnCount4: `@media (min-width: 1700px)`,

    pageHeaderResponsive2elements: `@media (max-width: ${mediaQueriesNumbers.pageHeaderResponsive2elementsMax}px)`,
    pageHeaderResponsive3elements: `@media (max-width: ${mediaQueriesNumbers.pageHeaderResponsive3elementsMax}px)`,

    screenHeightMin: `@media (min-height: ${mediaQueriesNumbers.ScreenHeightMin}px)`,
    screenHeightMax: `@media (max-height: ${mediaQueriesNumbers.ScreenHeightMax}px)`,
  };

  // Custom hook til at lytte efter skærmstørrelse
  export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const documentChangeHandler = () => setMatches(mediaQueryList.matches);

    // Lyt efter ændringer
    mediaQueryList.addEventListener('change', documentChangeHandler);

    // Ryd op ved unmount
    return () => {
      mediaQueryList.removeEventListener('change', documentChangeHandler);
    };
  }, [query]);

  return matches;
};

